<div class="backpage-wrapper">
  <div class="credential-library-container">
    <div class="header">
      <img
        src="../../../../assets/Logos/Overtur Logo.png"
        alt="overtur orange logo"
        width="60"
        height="50"
      />
      <h1>Overtur - Create Trial Subscription</h1>
    </div>
    <br />
  </div>
  <div class="overtur-subs-page" [formGroup]="form">
    <div class="sub-identifier-section">
      <div class="section-header">
        <mat-icon>info_outline</mat-icon>
        <h3>Subscription Information</h3>
      </div>
      <div class="fields">
        <mat-form-field class="full-width">
          <mat-label>SKU</mat-label>
          <mat-select formControlName="sku" placeholder="Select SKU">
            <mat-option
              *ngFor="let product of overturProducts"
              [value]="product.skuCode"
            >
              {{ product.skuCode }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="full-width">
          <mat-label>Duration</mat-label>
          <mat-select
            formControlName="trialPeriodDays"
            placeholder="Select Duration"
          >
            <mat-option
              *ngFor="let duration of durations"
              [value]="duration.value"
            >
              {{ duration.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="plan-description">
        <p>Plan Description: {{ planDescription }}</p>
      </div>
    </div>
    <div class="sub-identifier-section">
      <div class="section-header">
        <mat-icon>group_outline</mat-icon>
        <h3>Customer/Company Information</h3>
      </div>
      <div class="row-items">
        <mat-form-field class="full-width">
          <mat-label>End User Email</mat-label>
          <input
            matInput
            formControlName="endUserEmail"
            placeholder="Enter User's Email"
            maxlength="100"
            [class.loading]="emailValidationInProgress"
          />
          <mat-hint *ngIf="emailValidationInProgress"
            >Validating email...</mat-hint
          >

          <mat-error *ngIf="form.get('endUserEmail')?.hasError('required')">
            Email is required
          </mat-error>
          <mat-error *ngIf="form.get('endUserEmail')?.hasError('email')">
            Enter a valid email address
          </mat-error>
          <mat-error *ngIf="emailValidationError">
            {{ emailValidationError }}
          </mat-error>
        </mat-form-field>
        <div class="company-description" *ngIf="companyDetails">
          <p><strong>Company Information:</strong></p>
          <p>Company Name: {{ companyDetails.businessId }}</p>
          <p>Account Number: {{ companyDetails.accountNumber }}</p>
          <p>Account ID: {{ companyDetails.accountId }}</p>
          <p>
            City: {{ companyDetails.addressCity }} State:
            {{ companyDetails.addressState }}
          </p>
        </div>

        <div
          class="plan-description"
          *ngIf="!companyDetails && !emailValidationInProgress"
        >
          <p>No company information available.</p>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="submissionError"
    class="submission-error"
    role="alert"
    style="color: red; margin: 1em"
  >
    Trial Creation Failed: {{ submissionError }}
  </div>
  <div class="stepperControls padding s6 all">
    <button
      mat-button
      class="previousStepButton"
      routerLink="/overtur-admin-subscriptions"
    >
      Home
    </button>
    <button
      mat-button
      class="nextStepButton"
      (click)="submitTrial()"
      [disabled]="!form.valid || emailValidationInProgress"
    >
      Create Trial Subscription
    </button>
  </div>
</div>
